function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "E2D7DA89-554F-4AAD-9703-9EB50C1574CE");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "\\u9875\\u9762-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "2.-Predict-Stability-Score",
  transform: "translate(-860.000000, -60.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon_2",
  transform: "translate(860.000000, 60.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u7F16\\u7EC4-3"
}), /*#__PURE__*/React.createElement("g", {
  id: "\\u7F16\\u7EC4"
}), /*#__PURE__*/React.createElement("rect", {
  id: "\\u77E9\\u5F62",
  fill: "#008E8E",
  x: 0.967741935,
  y: 0,
  width: 58.0645161,
  height: 42.5806452,
  rx: 19.3548387
}), /*#__PURE__*/React.createElement("g", {
  id: "\\u7F16\\u7EC4-2",
  transform: "translate(13.548387, 7.319962)"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "\\u8DEF\\u5F84",
  stroke: "#FFFFFF",
  strokeWidth: 3.87096774,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  points: "13.5483871 30.9677419 23.2258065 21.2903226 29.0322581 29.0322581 42.5806452 15.483871"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "\\u4E09\\u89D2\\u5F62",
  stroke: "#FFFFFF",
  strokeWidth: 1.93548387,
  fill: "#FFFFFF",
  strokeLinejoin: "round",
  transform: "translate(42.932866, 15.061898) rotate(-315.000000) translate(-42.932866, -15.061898) ",
  points: "42.9328655 11.19093 47.7715752 18.9328655 38.0941558 18.9328655"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.516129,29.0322581 L44.516129,50.3225806 C53.5483871,39.1542004 58.0645161,32.0574263 58.0645161,29.0322581 C58.0645161,26.0070899 53.5483871,26.0070899 44.516129,29.0322581 Z",
  id: "\\u8DEF\\u5F84-2",
  fill: "#008E8E"
}))));

const SvgIcSimilarSequences = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "60px",
  height: "51px",
  viewBox: "0 0 60 51",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcSimilarSequences, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-similar-sequences.1565813d.svg";
export { ForwardRef as ReactComponent };